module.exports = __webpack_public_path__ + "img/WRLD0090---SML_TAPONMOBILE_TRADERPORTAL_2000x180.624b7e46.gif";